/**
 * Wat de beheerder aan de server vraagt: één functie per endpoint.
 *
 * Elke functie geeft de JSON van de server terug ({ success, data, detail }
 * of, bij een fout van de server, { detail }). Een mislukte verbinding
 * komt als fout uit fetch; het tabblad beslist wat de beheerder dan ziet.
 */
import { maakJson, stellingenEnPersonas } from './gedeeld';

export function maakBeheerApi(verzoek) {
  const h = maakJson(verzoek);
  const { json, post, put, verwijder, postParams } = h;

  return {
    ...stellingenEnPersonas(h),

    // stellingen en bronnen
    maakStelling: (titel, beschrijving, teacherId) =>
      postParams('/admin/statements', { titel, beschrijving, teacher_id: teacherId }),
    verwijderStelling: (id) => verwijder('/admin/statements/' + id),
    haalBron: (id) => json('/admin/statements/sources/' + id),
    maakTekstbron: (stellingId, { naam, inhoud, type }) =>
      post('/admin/statements/' + stellingId + '/sources', { naam, inhoud, type }),
    uploadBron: (stellingId, bestand, type, titelVoorLeerlingen) => {
      const formData = new FormData();
      formData.append('bestand', bestand);
      formData.append('type', type);
      formData.append('titel_voor_leerlingen', titelVoorLeerlingen);
      return json('/admin/statements/' + stellingId + '/sources/upload', { method: 'POST', body: formData });
    },
    wijzigBron: (id, naam, inhoud) => {
      const params = new URLSearchParams();
      if (naam) params.append('naam', naam);
      if (inhoud !== undefined) params.append('inhoud', inhoud);
      return json('/admin/statements/sources/' + id + '?' + params, { method: 'PUT' });
    },
    verwijderBron: (id) => verwijder('/admin/statements/sources/' + id),

    // persona's en portretten
    maakPersona: (persona) => post('/admin/personas', persona),
    wijzigPersona: (persona) => put('/admin/personas/' + persona.id, persona),
    verwijderPersona: (id) => verwijder('/admin/personas/' + id),
    haalPortretten: () => json('/admin/portretten'),
    uploadPortret: (bestand) => {
      const formData = new FormData();
      formData.append('bestand', bestand);
      return json('/admin/portretten', { method: 'POST', body: formData });
    },

    // agent-rollen
    haalAgentRollen: () => json('/admin/agent-rollen'),
    wijzigAgentRol: (rol) => put('/admin/agent-rollen/' + rol.id, rol),

    // prompts
    haalPromptCategorieen: () => json('/admin/prompts/categories'),
    haalPrompts: (categorie) => json(categorie ? '/admin/prompts?category=' + categorie : '/admin/prompts'),
    maakPrompt: (prompt) => post('/admin/prompts', prompt),
    wijzigPrompt: (prompt) => put('/admin/prompts/' + prompt.id, {
      name: prompt.name, description: prompt.description, prompt_text: prompt.prompt_text,
      is_active: prompt.is_active, sort_order: prompt.sort_order,
    }),
    verwijderPrompt: (id) => verwijder('/admin/prompts/' + id),
    zetPromptTerug: (id) => json('/admin/prompts/reset/' + id, { method: 'POST' }),
    laadStandaardPrompts: () => json('/admin/prompts/seed', { method: 'POST' }),

    // scholen en leerkrachten
    haalScholen: () => json('/admin/schools'),
    maakSchool: (school) => post('/admin/schools', school),
    verwijderSchool: (id) => verwijder('/admin/schools/' + id),
    maakLeerkracht: (leerkracht) => post('/admin/teachers', leerkracht),
    wijzigLeerkracht: (id, { naam, username, password }) => put('/admin/teachers/' + id, { naam, username, password }),
    verwijderLeerkracht: (id) => verwijder('/admin/teachers/' + id),

    // het logboek
    haalLogScholen: () => json('/admin/logs/schools'),
    haalLogKlassen: (schoolId) => json('/admin/logs/classes/' + schoolId),
    haalLogSessies: (klasId) => json('/admin/logs/sessions/' + klasId),
    haalLog: (sessieId) => json('/admin/logs/download/' + sessieId),
  };
}
